import React from "react";
import PropTypes from "prop-types";

const PaginationComponent = ({
  currentPage,
  totalPages,
  onNextPage,
  onPrevPage,
  onPageClick,
}) => {
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxDisplayedPages = 7;

    let startPage = Math.max(1, currentPage - 3);
    let endPage = Math.min(totalPages, startPage + maxDisplayedPages - 1);

    if (endPage - startPage + 1 < maxDisplayedPages) {
      startPage = Math.max(1, endPage - maxDisplayedPages + 1);
    }

    if (startPage > 1) {
      pageNumbers.push(
        <button
          key={1}
          onClick={() => onPageClick(1)}
          className="px-3 py-1 rounded-md border hover:bg-gray-100 transition"
        >
          1
        </button>,
      );

      if (startPage > 2) {
        pageNumbers.push(
          <span key="ellipsis1" className="px-2 text-gray-500">
            ...
          </span>,
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => onPageClick(i)}
          className={`px-3 py-1 rounded-md border transition ${
            currentPage === i
              ? "bg-green-600 text-white border-green-600"
              : "hover:bg-gray-100"
          }`}
        >
          {i}
        </button>,
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push(
          <span key="ellipsis2" className="px-2 text-gray-500">
            ...
          </span>,
        );
      }

      pageNumbers.push(
        <button
          key={totalPages}
          onClick={() => onPageClick(totalPages)}
          className="px-3 py-1 rounded-md border hover:bg-gray-100 transition"
        >
          {totalPages}
        </button>,
      );
    }

    return pageNumbers;
  };

  return (
    <div className="flex items-center justify-center gap-2 mt-4 flex-wrap mb-4 montserrat-font-1">
      {/* Prev Button */}
      <button
        onClick={onPrevPage}
        disabled={currentPage === 1}
        className={`px-3 py-1 rounded-md border transition ${
          currentPage === 1
            ? "opacity-40 cursor-not-allowed"
            : "hover:bg-gray-100"
        }`}
      >
        &lt;
      </button>

      {renderPageNumbers()}

      {/* Next Button */}
      <button
        onClick={onNextPage}
        disabled={currentPage === totalPages}
        className={`px-3 py-1 rounded-md border transition ${
          currentPage === totalPages
            ? "opacity-40 cursor-not-allowed"
            : "hover:bg-gray-100"
        }`}
      >
        &gt;
      </button>
    </div>
  );
};

PaginationComponent.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onNextPage: PropTypes.func.isRequired,
  onPrevPage: PropTypes.func.isRequired,
  onPageClick: PropTypes.func.isRequired,
};

export default PaginationComponent;
